import { render, staticRenderFns } from "./ResidentEnergyView.vue?vue&type=template&id=2e38dfaa&scoped=true"
import script from "./ResidentEnergyView.vue?vue&type=script&lang=js"
export * from "./ResidentEnergyView.vue?vue&type=script&lang=js"
import style0 from "./ResidentEnergyView.vue?vue&type=style&index=0&id=2e38dfaa&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2e38dfaa",
  null
  
)

export default component.exports